module.exports = __webpack_public_path__ + "media/iconic/media-09b2038b.svg";